














import { defineComponent } from '@vue/composition-api';
import ProductSwitcherSkeleton from './ProductSwitcherSkeleton.vue';
import { SdsSkeleton } from '@superbet-group/web.lib.ui-components';

export default defineComponent({
    components: {
        ProductSwitcherSkeleton,
        SdsSkeleton,
    },
});
